import $ from 'jquery'
import { getDateSeconds1 } from './commons';
export default { 
    data() {
      return { 
        actionName: "",
        multipleSelection: [],
        addModBoxVisible: false
      };
    },
 
    methods: { 
      resetModel: function() {
        for (const key in this.modelObj) {
          if (Object.prototype.hasOwnProperty.call(this.modelObj, key)) {
            this.modelObj[key] = "";
          }
        }
      },
      openModbox: function(msg) {
        //console.log(msg)
        this.isMode=true
        this.addModBoxVisible = true;
        this.actionName = "修改";
        if(msg.targetDuration){
          msg.targetDuration = msg.targetDuration + ''
        }
        if(!msg.targetDuration){
          msg.type=msg.type+""
        }
        this.modelObj =$.extend(true,{},msg) ;
        this.type=this.modelObj.type
        // if(type == 'road'){
        //   this.modelObj.vertex = ''
        //   this.modelObj.vertexList = ''
        //   this.modelObj.block = ''
        // }
      },
      openModbox2: function(msg) {
        //console.log(msg)
        this.addModBoxVisible = true;
        this.actionName = "修改";
        if(msg.roleName){
          let arr= msg.roleName.split(',')
          msg.roleName=arr
        }
        this.modelObj =$.extend(true,{},msg) ;
        // this.type=this.modelObj.type
        // if(type == 'road'){
        //   this.modelObj.vertex = ''
        //   this.modelObj.vertexList = ''
        //   this.modelObj.block = ''
        // }
      },
      openModbox1: function(msg) {
        //console.log(msg)
        this.addModBoxVisible = true;
        this.actionName = "修改";
        if(msg.targetDuration){
          msg.targetDuration = msg.targetDuration + ''
        }
        if(msg.type && msg.targetDuration){
          let type=msg.type
          if(typeof(type)=='object'){
            msg.type=type.map(item=>{return item*1})
            this.type[0]=msg.type[0]
          }else if(typeof(type)=='string'){
            msg.type=type.split(',')
            msg.type=msg.type.map(item=>{return item*1})
            this.type[0]=msg.type[0]
          }
        }
        this.modelObj =$.extend(true,{},msg) ;
      },
      openReadbox1: function(msg) {
        this.addModBoxVisible = true;
        this.actionName = "查看";
        this.islook=true
        if(msg.type && msg.targetDuration){
          let type=msg.type
          if(typeof(type)=='object'){
            msg.type=type.map(item=>{return item*1})
            this.type[0]=msg.type[0]
          }else if(typeof(type)=='string'){
            msg.type=type.split(',')
            msg.type=msg.type.map(item=>{return item*1})
            this.type[0]=msg.type[0]
          }
        }
        this.modelObj =$.extend(true,{},msg) ;
      },
      openReadbox: function(msg) {
        //console.log(msg)
        this.addModBoxVisible = true;
        this.actionName = "查看";
        this.islook=true
        if(msg.type){
          msg.type=(msg.type+"").split(',')
        }
        this.modelObj =$.extend(true,{},msg) ;
      },
      openAddBox: function(msg) {
        //console.log(msg)
        this.isMode=false
        this.addModBoxVisible = true;
        this.actionName = "新增";
        this.$refs.addModForm.resetFields()
        this.resetModel();
        this.actionName = "新增";
        this.modelObj =$.extend(true,{},msg) ;
        this.modelObj.createTime=getDateSeconds1()
      },
      resetSearch: function(){
        this.search = {pageNum:1,pageSize:10}
        let params = this.search;
        this.getDataList(params);
      },
      doSearch: function() {
        let params = this.search;
        this.getDataList(params);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      deleteBatch: function() {
        let _ids = [];
        let len = this.multipleSelection.length;
        let confirmMsg = "";
        for (let i = 0; i < len; i++) {
          const s = this.multipleSelection[i];
          _ids.push(s[this.fieldKey]);
          confirmMsg = confirmMsg + s[this.fieldRowName] + "<br>";
        }
        this.deleteDo(_ids, confirmMsg);
      },
      resetPass: function(msg){
        this.resetPassDo(msg[this.fieldKey], msg[this.fieldRowName]);
      },
      resetPassDo: function(id, confirmMsg){
        // const h = this.$createElement;
        this.$confirm(
          '确认对以下记录进行密码重置吗?' + "<br/>" + confirmMsg,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          let params={};
          params[this.fieldKey]=id;
          this.resetPassPost(params).then((res) => {
            //console.log(res)
            if(res.data.code == 200){
              this.$message({
                message: "操作成功!",
                type: "success"
              });
            }
            
            this.doSearch(this.lastQuery);
          });
        });
      },
      deleteSignAll: function(msg) { 
        //console.log(msg)
        this.deleteDo(msg,this.fieldKey);
    },
      deleteSign: function(msg) { 
          //console.log(msg)
        this.deleteDo(msg[this.fieldKey], msg[this.fieldRowName]);
      },
      deleteDo: function(id,fieldKey) {
        // const h = this.$createElement;
        this.$confirm(
          "确认对所选记录进行删除吗?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          let params={};
          params[fieldKey]=id;
          this.delPut(params).then((res) => {
            // console.log(res)
            this.showToast(res.data.code,res.data.message,'删除')
            this.doSearch(this.lastQuery);
          });
        });
      },
      addModSubmit: function() {
        let submitFun = this.addPost;
        
        if (this.actionName == "修改") {
          submitFun = this.modPut;
        }
        // console.log(this.modelObj) 
        this.$refs["addModForm"].validate(valid => {
          if (valid) {
            //console.log(this.modelObj)
            submitFun(this.modelObj).then((res) => {
              // console.log(res)
              this.showToast(res.data.code,res.data.message,this.actionName)
              if(res.data.code != 200){
                if(this.modelObj.type){
                  let arr=this.modelObj.type.split(',')
                  this.modelObj.type=arr.map(item=>{
                    return item*1
                  })
                }
                if(this.modelObj.roleName){
                  this.modelObj.roleName=this.modelObj.roleName.split(',')
                }
                return
              }
              this.addModBoxVisible = false;
              this.doSearch();
            });
          } else {
            //console.log("数据校验失败!");
            if(this.modelObj.type && !this.modelObj.roleName){
              let arr=this.modelObj.type.split(',')
              this.modelObj.type=arr.map(item=>{
                return item*1
              })
            }
            if(this.modelObj.roleName){
              this.modelObj.roleName=this.modelObj.roleName.split(',')
            }
            return false;
          }
        });
      },
      showToast: function(code,message,type){
        if(code != 200){
          // this.$message({
          //   message: message,
          //   type: "error"
          // });
        }else{
          this.$message({
            message: type + "成功!",
            type: "success"
          });
        }
      },
      setStatus: function(status, msg) {
        let _params = {};
        _params["status"] = status;
        _params[this.fieldKey] = msg[this.fieldKey];
        this.modPut(_params).then((res) => {
          //console.log(res)
          if(res.data.code == 200){
            this.$message({
              message: "操作成功!",
              type: "success"
            });
          }
          
        });
      }
    }
  };